"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlPaymentSchedulingOption = void 0;
var HlPaymentSchedulingOption;
(function (HlPaymentSchedulingOption) {
    HlPaymentSchedulingOption["PERIOD_START"] = "PERIOD_START";
    HlPaymentSchedulingOption["PERIOD_MIDDLE"] = "PERIOD_MIDDLE";
    HlPaymentSchedulingOption["PERIOD_END"] = "PERIOD_END";
})(HlPaymentSchedulingOption = exports.HlPaymentSchedulingOption || (exports.HlPaymentSchedulingOption = {}));
//# sourceMappingURL=HlPaymentSchedulingOption.js.map